import React from "react";

import interviewvideo from "../../img/interviewvideo.mp4";

const Video = () => {
  return (
    <>
      <div className="videobox">
        <div className="myvideo">
          {/* The video */}
          <h4 className="part">Introduction Video</h4>
          <video controls loop autoplay id="myVideo">
            <source src={interviewvideo} type="video/mp4" />
          </video>
          {/* Optional: some overlay text to describe the video */}
        </div>
      </div>
    </>
  );
};

export default Video;
